import { useNavigate } from 'react-router-dom';
import CloseCircle from '../../../assets/icons/CloseCircle';
import ShareIcon from '../../../assets/icons/ShareIcon';
import { getIcLink } from '../../../helpers/getIcLink';
import Button from '../../../ui/Button';
import ButtonNew from '../../../ui/ButtonNew';

function MintedProjectBack({ image, ic }) {
    console.log('test ic share feature', ic);
    const navigate = useNavigate()
    // #F5FAFF
    console.log(ic, "render chain detail")
    return (


        <div className=' flex items-center justify-center  w-full' >
            <div>

                <div className="flex flex-col items-center gap-4">
                    <ButtonNew
                        onClick={() => {
                            window.open(image, '_blank');
                        }}
                        variant="blue"
                        className=" py-1 px-6  flex  items-center justify-center gap-2  "
                        size='md'
                        fixedMinWidth={true}

                    >
                        <span className='flex items-center gap-2'>
                            <span >
                                {' '}
                                Share{' '}
                            </span>{' '}
                            <ShareIcon fillColor="#fff" />

                        </span>

                    </ButtonNew>

                    <p className='text-xs font-semibold text-[#fff]' >OR</p>
                    <Button
                        onClick={() => {
                            navigate(`/profile/gallery/projectic/${ic?._id}`)
                        }}
                        variant="primary"
                        className="text-base flex items-center justify-center gap-2 py-3 px-6 font-medium"
                        size='none'
                        radius='rounded-lg'
                    >

                        View Impact Report
                        <span>
                            <svg className='w-6 h-6' xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                <path d="M19.7799 19.0263H5.61328V6.2763H7.02995V15.1588L10.9258 8.4013L15.5299 11.0788L18.5333 5.88672L19.7587 6.59505L19.7799 19.0263Z" fill="white" />
                            </svg>

                        </span>
                    </Button>
                </div>
                <div className="flex items-center justify-center mt-2">
                    <div className="flex items-center  gap-1  ">
                        <img className="w-5 h-5 rounded-full" src={ic?.blockchain?.image} alt={ic?.paymentDetails?.paymentBlockchain} />
                        <p className="text-sm flex-1 text-[#fff]">
                            View it on{' '}
                            <a
                                className="underline cursor-pointer "
                                href={getIcLink(ic?.paymentDetails.paymentTokenAddress, ic?.paymentDetails?.paymentBlockchain)}
                                target="_blank"
                            >
                                <span className="capitalize ">{ic?.paymentDetails?.paymentBlockchain} </span> blockchain
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default MintedProjectBack;
